/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useResubmitClaimStatusRequest
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { redirectToClaimDetailScreen } from './usePostClaimStatusRequest';
import { useClaimStatusRequestsStoreActions } from 'store/claimsRequests';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for resubmit claim status request
 *
 */
interface IProps {
	claimId: string;
}
const useResubmitClaimStatusRequest = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	const { setPageNumber } = useClaimStatusRequestsStoreActions();
	return useMutation({
		mutationFn: async ({ claimId }) => {
			const { data } = await api.EzapiApi.postClaimStatusResubmitRequest({ claimId });
			return data as ClaimStatusResponse.IModel[];
		},
		onSuccess: (data) => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimRequestById] });
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimStatusRequests] });
			redirectToClaimDetailScreen(data, setPageNumber);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useResubmitClaimStatusRequest;
